export const GoogleMapApiConfig = 'AIzaSyC5op-E-1gTgCrD4CdP2TVVsIHN_fHK3cE';